import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { FilterKey } from '../../interfaces/ProductFilter/FilterKey';
import { getFilterKeys } from '../../api/ProductFilter';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { FilterKeysTable } from './FilterKeysTable';

export const FiltersPage = () => {
  const navigate = useNavigate();

  const [filterKeys, setFilterKeys] = useState<FilterKey[]>([]);
  const [loading, setLoading] = useState(false);

  const refreshFilterKeys = () => {
    setLoading(true);
    getFilterKeys()
      .then((f) => setFilterKeys(f))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshFilterKeys();
  }, []);

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        Filtreler
      </Typography>
      <Waiting open={loading} />
      <Button
        variant='contained'
        startIcon={<AddIcon />}
        onClick={() => navigate('/products/filters/new')}
        sx={{ ...sharedStyles.buttonText, mb: 1.5 }}
      >
        Yeni Filtre
      </Button>
      <FilterKeysTable filterKeys={filterKeys} />
    </Box>
  );
};
